import GroupView from '@/components/dialogs/BulkDebtorsDialog/GroupView';
import { MAX_PER_API_BATCH_SIZE } from '@/utils/constants';
import { Stack, Typography } from '@mui/material';
import React, { useMemo } from 'react';

const getSkippedCounts = (skipped = []) =>
	skipped.reduce((acc, item) => {
		const key = item.reason === 'missing-client' ? item.reason : 'skipped';
		acc[key] = (acc[key] ?? 0) + 1;
		return acc;
	}, {});

const ShowPreview = ({ preview }) => {
	const groups = preview.groups ?? [];

	const skippedCounts = useMemo(() => getSkippedCounts(preview?.skipped), [preview?.skipped]);

	const skippedSummary = useMemo(() => {
		const amount = skippedCounts.skipped;
		if (amount > 0) {
			return `Some matching transactions were not included because they already have debtor deals in progress or due to the ${MAX_PER_API_BATCH_SIZE} debtor limit.`;
		}
	}, [skippedCounts]);

	const transactionText = useMemo(() => {
		const total = preview.totals?.eligibleTransactions ?? 0;
		return total > 0 ? ` from ${total} eligible transactions.` : '.';
	}, [preview.totals?.eligibleTransactions]);

	const noDeals = useMemo(
		() => preview.totals?.groups === 0 && preview.totals?.skipped === 0,
		[preview.totals?.groups, preview.totals?.skipped],
	);

	return (
		<Stack spacing={2}>
			{noDeals ? (
				<Typography variant='body2'>
					No eligible debtor deals found for that range.
				</Typography>
			) : (
				<>
					<Typography variant='body2'>
						{`${preview.totals?.groups ?? 0} debtor deals will be created${transactionText}`}
					</Typography>
					{preview.totals?.skipped > 0 && (
						<>
							{skippedSummary && (
								<Typography variant='body2'>{skippedSummary}</Typography>
							)}
							{skippedCounts['missing-client'] > 0 && (
								<Typography variant='body2'>
									{`${skippedCounts['missing-client']} were skipped due to a client missing in Folio.`}
								</Typography>
							)}
						</>
					)}
				</>
			)}

			<Stack spacing={1}>
				{groups.map((group) => (
					<GroupView
						key={`${group.clientId}-${group.yearFolder}-${group.dealName}`}
						{...group}
					/>
				))}
			</Stack>
		</Stack>
	);
};
ShowPreview.displayName = 'ShowPreview';
export default ShowPreview;
